export default __webpack_public_path__ + "media/images/hover1-6470ffa69647d2f502e44b594aad6c31.png";